import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { prepareSearchParams } from '@/libs/helper'

const resource = `${Config.basePath}/service-system`

export default {
  index(payload) {
    return Client.get(`${resource}/performance`, {
      params: prepareSearchParams(payload),
    })
  },
  exportExcel(payload) {
    return Client.get(`${resource}/performance/download`, {
      params: payload,
    })
  },
}
